export function validateEmail(email: string) {
  const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  if (!regex.test(email)) {
    return 'Invalid email address';
  }
  return true; // Return empty string if validation succeeds
}

type Props = {
  timezone: string;
};
